"use client"

import { useState, useEffect } from "react"
import { DEVICE_BREAKPOINTS } from "../configs/animations"


export function useMobileDetection() {
  const [isMobile, setIsMobile] = useState(false)
  const [isTablet, setIsTablet] = useState(false)
  const [screenWidth, setScreenWidth] = useState(0)
  const [screenHeight, setScreenHeight] = useState(0)

  useEffect(() => {
    const checkDevice = () => {
      const width = window.innerWidth
      const height = window.innerHeight
      setScreenWidth(width)
      setScreenHeight(height)
      setIsMobile(width < DEVICE_BREAKPOINTS.MOBILE)
      setIsTablet(width >= DEVICE_BREAKPOINTS.MOBILE && width < DEVICE_BREAKPOINTS.TABLET)
    }

    // Verificar al montar
    checkDevice()

    // Agregar listeners
    window.addEventListener("resize", checkDevice)
    window.addEventListener("orientationchange", checkDevice)

    return () => {
      window.removeEventListener("resize", checkDevice)
      window.removeEventListener("orientationchange", checkDevice)
    }
  }, [])

  return {
    isMobile,
    isTablet,
    isDesktop: !isMobile && !isTablet,
    screenWidth,
    screenHeight,
  }
}
